import { render, staticRenderFns } from "./fccProvasEspeciais.vue?vue&type=template&id=17e82ae0"
import script from "./fccProvasEspeciais.vue?vue&type=script&lang=js"
export * from "./fccProvasEspeciais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports